import { FileServiceResponse } from './interfaces/files-cache.interface';
import { CachePlugin } from './cache.plugin';
import { FILESCACHE_KEYS } from './enums/files-cache.enum';

export class FilesCachePlugin extends CachePlugin {

  public async getUrlFile(filename: string) {
    try {
      const { file } = await this.getFile(filename);
      return file ? URL.createObjectURL(file) : null;
    } catch {
      return null;
    }
  }

  public async getFile(filename: string): Promise<FileServiceResponse> {
    this.storeData = FILESCACHE_KEYS.STORE_VAL;
    let response = await this.getFileData(filename);
    if(this.indexDB && response.file) {
      response.file = new Blob([response.file], { type: 'application/pdf' });
    }
    return response;
  }

  public async cacheFile(filename: string, data: any): Promise<FileServiceResponse> {
    this.storeData = FILESCACHE_KEYS.STORE_VAL;
    return await this.cacheFileData(filename, data);
  }
  
}

export const FilesCache = {
  install: (Vue) => {
    Vue.prototype.$FilesCache = new FilesCachePlugin();
  }
}
